var map = {
	"./admin_settings.png": 1759,
	"./catalog.png": 1760,
	"./catalogWhite.png": 1761,
	"./catalog_orders.png": 1762,
	"./cms.png": 1763,
	"./component-fields/Asset.png": 1764,
	"./component-fields/Blocks.png": 1765,
	"./component-fields/Boolean.png": 1766,
	"./component-fields/Date-time.png": 1767,
	"./component-fields/LInk.png": 1768,
	"./component-fields/Markdown.png": 1769,
	"./component-fields/Multi asset.png": 1770,
	"./component-fields/Multi options.png": 1771,
	"./component-fields/Number.png": 1772,
	"./component-fields/Richtext.png": 1773,
	"./component-fields/Single options.png": 1774,
	"./component-fields/Table.png": 1775,
	"./component-fields/Text area.png": 1776,
	"./component-fields/Text.png": 1777,
	"./components.png": 1778,
	"./configuration.png": 1779,
	"./contents.png": 1780,
	"./crm.png": 1781,
	"./custom_order.png": 1782,
	"./customer_credits.png": 1783,
	"./customer_list.png": 1784,
	"./dashboard.png": 1785,
	"./finance.png": 1786,
	"./home.png": 1787,
	"./integrations.png": 1788,
	"./inventory-transfers.png": 1789,
	"./invoice-list.png": 1790,
	"./layaway.png": 1791,
	"./move.png": 1792,
	"./new_sale.png": 1793,
	"./orders.png": 1794,
	"./outgoing-consignments.png": 1795,
	"./payment-methods/amex.png": 1177,
	"./payment-methods/discover.png": 1176,
	"./payment-methods/mastercard.png": 1175,
	"./payment-methods/visa.png": 1174,
	"./payments.png": 1796,
	"./register.png": 1797,
	"./repair_center.png": 1798,
	"./reports.png": 1799,
	"./services.png": 1800,
	"./trade_in_center.png": 1801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1412;